import { api } from '@/core/api/';

const baseApiURL = 'api/proposal/process';

export const getInitFilters = async (announcementId) => {
  return await api.get(`api/proposal/process/initfilters/${announcementId}`);
};

export const getAreaAndProvidersNameFilters = async (academicYear) => {
  return await api.get('api/proposal/process/areaandprovidersnamefilters', {
    params: {
      academicYear,
    },
  });
};

export const getProposalRequests = async (filters) => {
  return await api.get('api/proposal/process/searchproposalrequests', {
    params: {
      ...filters,
    },
  });
};

export const checkBusySsn = async (proposalRequestId) =>
  api.get(`api/proposal/process/checkbusyssn/${proposalRequestId}`);

export const determineProposalRequest = async (payload) => {
  return await api.post(
    'api/proposal/process/determineproposalrequest',
    payload
  );
};

export const getProposalRequestStatusHistory = async (
  proposalRequestId,
  pageIndex,
  pageSize
) => {
  return await api.get('api/proposal/process/proposalrequeststatushistory', {
    params: {
      proposalRequestId,
      pageIndex,
      pageSize,
    },
  });
};

export const getLetters = async (announcementId, pageIndex, pageSize) => {
  return await api.get('api/proposal/process/searchletters', {
    params: {
      announcementId,
      pageIndex,
      pageSize,
    },
  });
};

export const getDeterminationLetterAsync = async (announcementId, letterId) => {
  return await api.get(
    `api/report/determinationletter/${announcementId}/${letterId}`
  );
};

export const getLetterDetail = async (letterId, letterTypeId) => {
  return await api.get(`api/proposal/process/${letterId}/detail`, {
    params: {
      letterTypeId,
    },
  });
};

export const getAwardLetterAsync = async (announcementId, letterId) => {
  return await api.get(`api/report/awardletter/${announcementId}/${letterId}`);
};

export const addLetter = async (letter) => {
  return await api.post('api/proposal/process/addletter', letter, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};
export const saveAmendment = async (payload) => {
  return await api.post('api/proposal/process/saveamendment', payload);
};
export const addLetterDocument = async (letterId, doc) => {
  return await api.post(`api/proposal/process/${letterId}/addletterdoc`, doc);
};

export const addAwardLetter = async (announcementId) => {
  return await api.post(
    `api/proposal/process/addawardletter/${announcementId}`
  );
};

export const getRenewalTermTypes = async () =>
  await api.get(`api/proposal/process/renewaltermtypes`);

export const getParticipantTypes = async () =>
  await api.get(`api/proposal/process/participanttypes`);

export const getCodeLetterTypes = async () =>
  await api.get(`api/proposal/process/lettertypes`);

export const getProposalRequestDocuments = async (proposalRequestId) => {
  return await api.get(
    `api/proposal/process/proposalrequestdocuments/${proposalRequestId}`
  );
};

export const getProposalRequestDocument = async (documentId) => {
  return await api.get(
    `api/proposal/process/proposalrequestdocument/${documentId}`
  );
};
export const getDetail = async (id) => {
  return await api.get(`${baseApiURL}/detail/${id}`);
};

export const getProposalDeterminationDocuments = async (proposalRequestId) =>
  await api.get(
    `api/proposal/process/determinationdocuments/${proposalRequestId}`
  );

export const uploadDeterminationDocument = (payload) =>
  api.post(`api/proposal/process/savedeterminationdocument`, payload, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

export const getAreas = (academicYear) =>
  api.get(`api/proposal/process/areas/${academicYear}`);

export const getInitialDataToCreate = (params = {}) =>
  api.get(`api/proposal/process/initialdatatocreate`, { params });

export const getAnnouncementDetail = (announcementId) =>
  api.get(`api/proposal/process/announcementdetail/${announcementId}`);

export const getAnnoncements = (payload) =>
  api.get(`api/proposal/process/announcements`, {
    params: payload,
  });

export const saveAnnouncement = async (params) => {
  return await api.post('api/proposal/process/announcements', params, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const deleteDocumentTypeOfAnnouncement = (
  announcementId,
  proposalDocumentTypeId
) =>
  api.delete(
    `api/proposal/process/deletedocumenttypeofannouncement/${announcementId}/${proposalDocumentTypeId}`
  );

export const updateDocumentTypeOfAnnouncement = (announcementId, payload) =>
  api.put(
    `${baseApiURL}/updatedocumenttypeofannouncement/${announcementId}`,
    payload
  );

export const getDocumentTypesByAnnouncement = (announcementId) =>
  api.get(`api/proposal/process/documenttypebyannouncement/${announcementId}`);

export const reorderAnnouncementDocuments = (payload) =>
  api.put(`api/proposal/process/reorderannouncementdocuments`, payload);

export const getDocumentTypesOfAnnouncementByRecruitmentType = (
  announcementId,
  recruitmentTypeId
) =>
  api.get(
    `api/proposal/process/documenttypesofannouncementbyrecruitmenttype/${announcementId}/${recruitmentTypeId}`
  );

export const addDocumentTypeeToAnnouncement = (payload) =>
  api.post(`api/proposal/process/adddocumenttypeetoannouncement`, payload);

export const upsertEvaluators = (payload) =>
  api.post(`api/proposal/process/save/evaluators`, payload);

export const submitAnnouncement = (announcementId) =>
  api.put(`api/proposal/process/submitannouncement/${announcementId}`);

export const getPreliminarSearchInitFilters = async () =>
  api.get('api/proposal/process/initfilters');

export const resetDeterminationProposalRequest = async (payload) => {
  return await api.post(
    'api/proposal/process/resetdeterminationproposalrequest',
    payload
  );
};

export const removeProposalRequestDeterminationDocument = async (
  proposalRequestId,
  documentId
) => {
  return await api.delete(
    'api/proposal/process/removeproposalrequestdeterminationdocument',
    {
      params: {
        proposalRequestId,
        documentId,
      },
    }
  );
};

export const addBitacoraItem = (proposalRequestId, payload) =>
  api.post(`${baseApiURL}/addbitacoraitem/${proposalRequestId}`, payload, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

export const getBitacoraItems = (proposalRequestId) =>
  api.get(`${baseApiURL}/bitacoraitems/${proposalRequestId}`);

export const finalizeProposalProcess = (announcementId) =>
  api.put(`${baseApiURL}/finalizeproposalprocess/${announcementId}`);

export const getProposalRequestDetails = async (proposalRequestId) => {
  return api.get(
    `api/proposal/process/proposalrequestdetails/${proposalRequestId}`
  );
};

export const getLetterAmendmentHistory = async (letterId) => {
  return api.get(`api/proposal/process/${letterId}/letteramendmenthistory`);
};

export const sendInvitation = (announcementId) =>
  api.put(`api/proposal/process/sendinvitation/${announcementId}`);
